<template>
  <el-tooltip 
    v-model:visible="visible"
    placement="top" 
    :effect="props.effect"
    :popper-class="`global-popper ${props.type ? 'type-' + props.type : ''}`"
  >
    <slot />
    
    <template v-if="slots.content" #content>
      <div v-if="slots.title || slots.icon" :class="['global-popper-content-wrapper', style.content]">
        <div v-if="slots.icon" class="global-popper-icon">
          <slot name="icon" />
        </div>
        <div class="global-popper-content-inner">
          <div v-if="slots.title" class="global-popper-title">
            <slot name="title" />
          </div>
          <slot name="content" />
        </div>
        <div v-if="props.closable" class="global-popper-close" @click="handleClose">
          <!-- <span /> -->
          <SvgIcon icon="Icon-Default-Close" />
        </div>
      </div>
      <div v-else :class="[style.content]">
        <slot name="content" />
      </div>
    </template>
  </el-tooltip>
</template>

<script setup lang="ts">
const props = defineProps({
  type: {
    type: String,
    default: ''
  },
  closable: {
    type: Boolean,
    default: false
  },
  effect: {
    validator(value: string) {
      return ['dark', 'light', 'orange'].indexOf(value) > -1;
    },
    type: String,
    default: 'dark'
  }
});
const slots = useSlots();
const visible = ref(false);
function handleClose() {
  visible.value = false;
}
</script>

<style lang="scss" module="style">
.content{
  // overflow: hidden;
}
</style>

<style lang="scss">
.global-popper.el-popper {
  border-radius: 6px;
  // font-weight: 500;
  line-height: 18px;
  min-width: 20px;
  max-width: 200px;
  padding: 8px 8px;
  word-break: break-word;

  & > .global-popper-content-wrapper {
    display: flex;

    & > .global-popper-icon {
      display: flex;
      align-items: center;
      margin-inline-end: 4px;
      width: 16px;
      height: 18px;
      svg {
        width: 16px;
        height: 16px;
      }
    }
    & > .global-popper-close {
      display: flex;
      align-items: center;
      margin-inline-start: 4px;
      width: 16px;
      height: 18px;
      cursor: pointer;
      svg {
        width: 16px;
        height: 16px;
        // background: url("@/assets/img/element/Default/Close-dark.svg") 0 0/100% no-repeat;
      }
    }
    & > .global-popper-content-inner {
      flex: 1;
      & > .global-popper-title {
        margin-bottom: 4px;
        line-height: 18px;
        font-size: 14px;
        font-weight: 500;
        display: -webkit-box;
        overflow: hidden;
        text-overflow: ellipsis;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }
    }
  }

  &.is-dark {
    color: var(--unified-unified1);
    background: var(--toasts-toasts1);
    border: 1px solid var(--toasts-toasts1);
    .el-popper__arrow:before {
      background: var(--toasts-toasts1) !important;
    }
  }
  &.is-orange {
    color: var(--text-text1);
    background: var(--warning-warning4);
    border: 1px solid var(--warning-warning4);
    .el-popper__arrow:before {
      background: var(--warning-warning4) !important;
    }
    & > .global-popper-content-wrapper > .global-popper-close {
      span {
        // background: url("@/assets/img/element/Default/Close.svg") 0 0/100% no-repeat;
      }
    }
  }

  &.type-xl {
    width: 200px;
    padding: 12px 12px;
    border-radius: 8px;
  }
  &.type-xxl {
    width: 300px;
    max-width: unset;
    padding: 12px 12px;
    border-radius: 8px;
    & > .global-popper-content-wrapper > .global-popper-icon {
      margin-inline-end: 12px;
      width: 20px;
      height: 20px;
      svg {
        width: 20px;
        height: 20px;
      }
    }
    & > .global-popper-content-wrapper > .global-popper-close {
      margin-inline-start: 12px;
      width: 20px;
      height: 20px;
      svg {
        width: 20px;
        height: 20px;
      }
    }
    & > .global-popper-content-inner > .global-popper-title {
      line-height: 20px;
    }
  }

  &.el-popper[data-popper-placement^=bottom].is-dark .el-popper__arrow:before {
    border-top-color: var(--toasts-toasts1) !important;
    border-left-color: var(--toasts-toasts1) !important;
    border-bottom-color: transparent !important;
    border-right-color: transparent !important;
  }

  &.el-popper[data-popper-placement^=top].is-dark .el-popper__arrow:before {
    border-bottom-color: var(--toasts-toasts1) !important;
    border-right-color: var(--toasts-toasts1) !important;
    border-top-color: transparent !important;
    border-left-color: transparent !important;
  }

  &.el-popper[data-popper-placement^=left].is-dark .el-popper__arrow::before {
    border-top-color: var(--toasts-toasts1) !important;
    border-right-color: var(--toasts-toasts1) !important;
    border-bottom-color: transparent !important;
    border-left-color: transparent !important;
  }

  &.el-popper[data-popper-placement^=right].is-dark .el-popper__arrow::before {
    border-bottom-color: var(--toasts-toasts1) !important;
    border-left-color: var(--toasts-toasts1) !important;
    border-top-color: transparent !important;
    border-right-color: transparent !important;
  }
}
.dark {
  .global-popper.el-popper.is-orange {
    & > .global-popper-content-wrapper > .global-popper-close {
      svg {
        // background: url("@/assets/img/element/Default/Close-dark.svg") 0 0/100% no-repeat;
      }
    }
  }
}
</style>
